import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
  UserOutlined,
  DashboardOutlined,
  UnorderedListOutlined,
  CloudServerOutlined,
  ArrowDownOutlined,
  DollarOutlined,
  BarcodeOutlined,
  ScheduleOutlined,
  CarOutlined,
  FileDoneOutlined,
  LineChartOutlined
} from '@ant-design/icons';
import { Auth } from 'aws-amplify';

import { checkRouleProfileAccess } from 'utils/checkRouleProfileAccess';
import { appRoutes, roules } from 'utils/defaultValues';
import { useAppContext } from 'hooks/contextLib';

const { SubMenu } = Menu;
const { Sider } = Layout;

const SliderMenu: React.FC = (props: any) => {
  const { collapsed, width } = useAppContext();
  const [groupsUser, setGroupsUser] = useState<string[]>([]);

  useEffect(() => {
    onLoad();
  }, []);

  const onLoad = async () => {
    try {
      const userAuth = await Auth.currentAuthenticatedUser();
      setGroupsUser(
        userAuth.signInUserSession.accessToken.payload['cognito:groups']
      );
    } catch (e) {
      if (e !== 'No current user' && e !== 'The user is not authenticated') {
        console.log(e);
      }
    }
  };
  const menuItem = () => {
    return (
      checkRouleProfileAccess(groupsUser, roules.products) && (
        <SubMenu
          key={`sub-/${appRoutes.products}`}
          title={'Produtos'}
          icon={<BarcodeOutlined />}
        >
          <Menu.Item key={`/${appRoutes.products}`}>
            <Link to={`/${appRoutes.products}`}>Lista</Link>
          </Menu.Item>
          <Menu.Item key={`/${appRoutes.products}/create`}>
            <Link to={`/${appRoutes.products}/create`}>Novo</Link>
          </Menu.Item>
        </SubMenu>
      )
    );
  };
  return (
    <Sider
      width={230}
      collapsedWidth={width < 650 ? 0 : 80}
      collapsible
      trigger={null}
      collapsed={collapsed}
    >
      <Menu
        mode="inline"
        selectedKeys={[props?.location.pathname]}
        defaultOpenKeys={
          width < 650 ? [] : [`sub-/${props?.location.pathname.split('/')[1]}`]
        }
        style={{ height: '100%', borderRight: 0 }}
      >
        <Menu.Item key={'/'} icon={<DashboardOutlined />}>
          <Link to={'/'}>Dashboard</Link>
        </Menu.Item>

        {checkRouleProfileAccess(groupsUser, roules.sales) && (
          <Menu.Item key={'/dre'} icon={<LineChartOutlined />}>
            <Link to={'/dre'}>DRE</Link>
          </Menu.Item>
        )}
        {checkRouleProfileAccess(groupsUser, roules.expenses) && (
          <SubMenu
            key={`sub-/${appRoutes.expenses}`}
            title={'Pagamentos'}
            icon={<ArrowDownOutlined />}
          >
            <Menu.Item key={`/${appRoutes.expenses}`}>
              <Link to={`/${appRoutes.expenses}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.expenses}/create`}>
              <Link to={`/${appRoutes.expenses}/create`}>Novo</Link>
            </Menu.Item>
          </SubMenu>
        )}
        {checkRouleProfileAccess(groupsUser, roules.clients) && (
          <SubMenu
            key={`sub-/${appRoutes.clients}`}
            title="Clientes"
            icon={<UserOutlined />}
          >
            <Menu.Item key={`/${appRoutes.clients}`}>
              <Link to={`/${appRoutes.clients}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.clients}/create`}>
              <Link to={`/${appRoutes.clients}/create`}>Novo</Link>
            </Menu.Item>
          </SubMenu>
        )}
        {checkRouleProfileAccess(groupsUser, roules.visit) && (
          <SubMenu
            key={`sub-/${appRoutes.visits}`}
            title={'Visitas'}
            icon={<ScheduleOutlined />}
          >
            <Menu.Item key={`/${appRoutes.visits}`}>
              <Link to={`/${appRoutes.visits}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.visits}/create`}>
              <Link to={`/${appRoutes.visits}/create`}>Nova</Link>
            </Menu.Item>
          </SubMenu>
        )}
        {checkRouleProfileAccess(groupsUser, roules.contracts) && (
          <SubMenu
            key={`sub-/${appRoutes.contracts}`}
            title={'Contratos'}
            icon={<FileDoneOutlined />}
          >
            <Menu.Item key={`/${appRoutes.contracts}`}>
              <Link to={`/${appRoutes.contracts}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.contracts}/create`}>
              <Link to={`/${appRoutes.contracts}/create`}>Novo</Link>
            </Menu.Item>
          </SubMenu>
        )}
        {checkRouleProfileAccess(groupsUser, roules.sales) && (
          <SubMenu
            key={`sub-/${appRoutes.sales}`}
            title={'Vendas'}
            icon={<DollarOutlined />}
          >
            <Menu.Item key={`/${appRoutes.sales}`}>
              <Link to={`/${appRoutes.sales}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.sales}/create`}>
              <Link to={`/${appRoutes.sales}/create`}>Nova</Link>
            </Menu.Item>
            {/* <Menu.Item key={`/${appRoutes.sales}/my-commisions`}>
              <Link to={`/${appRoutes.sales}/my-commisions`}>
                Minhas comissões
              </Link>
            </Menu.Item> */}
          </SubMenu>
        )}
        {checkRouleProfileAccess(groupsUser, roules.applications) && (
          <SubMenu
            key={`sub-/${appRoutes.applications}`}
            title={'Aplicações'}
            icon={<UnorderedListOutlined />}
          >
            <Menu.Item key={`/${appRoutes.applications}`}>
              <Link to={`/${appRoutes.applications}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.applications}/create`}>
              <Link to={`/${appRoutes.applications}/create`}>Nova</Link>
            </Menu.Item>
          </SubMenu>
        )}
        {checkRouleProfileAccess(groupsUser, roules.products) && (
          <SubMenu
            key={`sub-/${appRoutes.products}`}
            title={'Produtos'}
            icon={<BarcodeOutlined />}
          >
            <Menu.Item key={`/${appRoutes.products}`}>
              <Link to={`/${appRoutes.products}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.products}/create`}>
              <Link to={`/${appRoutes.products}/create`}>Novo</Link>
            </Menu.Item>
          </SubMenu>
        )}
        {checkRouleProfileAccess(groupsUser, roules.suppliers) && (
          <SubMenu
            key={`sub-/${appRoutes.suppliers}`}
            title="Fornecedores"
            icon={<UserOutlined />}
          >
            <Menu.Item key={`/${appRoutes.suppliers}`}>
              <Link to={`/${appRoutes.suppliers}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.suppliers}/create`}>
              <Link to={`/${appRoutes.suppliers}/create`}>Novo</Link>
            </Menu.Item>
          </SubMenu>
        )}
        {checkRouleProfileAccess(groupsUser, roules.shopping) && (
          <SubMenu
            key={`sub-/${appRoutes.shopping}`}
            title={'Compras'}
            icon={<ArrowDownOutlined />}
          >
            <Menu.Item key={`/${appRoutes.shopping}`}>
              <Link to={`/${appRoutes.shopping}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.shopping}/create`}>
              <Link to={`/${appRoutes.shopping}/create`}>Nova</Link>
            </Menu.Item>
          </SubMenu>
        )}
        {checkRouleProfileAccess(groupsUser, roules.administrator) && (
          <>
            <SubMenu
              key={`sub-/${appRoutes.companies}`}
              title={'Empresas'}
              icon={<UnorderedListOutlined />}
            >
              <Menu.Item key={`/${appRoutes.companies}`}>
                <Link to={`/${appRoutes.companies}`}>Lista</Link>
              </Menu.Item>
              <Menu.Item key={`/${appRoutes.companies}/create`}>
                <Link to={`/${appRoutes.companies}/create`}>Nova</Link>
              </Menu.Item>
            </SubMenu>
          </>
        )}
        {checkRouleProfileAccess(groupsUser, roules.vehicles) && (
          <SubMenu
            key={`sub-/${appRoutes.vehicles}`}
            title={'Veiculos'}
            icon={<CarOutlined />}
          >
            <Menu.Item key={`/${appRoutes.vehicles}`}>
              <Link to={`/${appRoutes.vehicles}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.vehicles}/create`}>
              <Link to={`/${appRoutes.vehicles}/create`}>Novo</Link>
            </Menu.Item>
          </SubMenu>
        )}

        {checkRouleProfileAccess(groupsUser, roules.users) && (
          <SubMenu
            key={`sub-/${appRoutes.users}`}
            title="Usuários"
            icon={<UserOutlined />}
          >
            <Menu.Item key={`/${appRoutes.users}`}>
              <Link to={`/${appRoutes.users}`}>Lista</Link>
            </Menu.Item>
            <Menu.Item key={`/${appRoutes.users}/create`}>
              <Link to={`/${appRoutes.users}/create`}>Novo</Link>
            </Menu.Item>
          </SubMenu>
        )}

        {checkRouleProfileAccess(groupsUser, roules.developers) && (
          <>
            <Menu.Item
              icon={<CloudServerOutlined />}
              key={`/${appRoutes.services}`}
            >
              <Link to={`/${appRoutes.services}`}>Serviços</Link>
            </Menu.Item>
            <Menu.Item
              icon={<UnorderedListOutlined />}
              key={`/${appRoutes.expenseTypes}`}
            >
              <Link to={`/${appRoutes.expenseTypes}`}>Tipos de Despesas</Link>
            </Menu.Item>
          </>
        )}
      </Menu>
    </Sider>
  );
};

export default SliderMenu;
